import { FC, ReactNode, useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Flex,
  rem,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { MainHeader } from "../entities/components/header/MainHeader";
import { MainSidebar } from "../entities/components/main-sidebar/MainSidebar";

import useAuthStore from "../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

interface Props {
  children: ReactNode;
}

export const MainLayout: FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery("(max-width: 670px)");

  const theme = useMantineTheme();
  const { showAlert, setShowAlert } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (matches && open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [matches, open]);

  const location = useLocation();

  return (
    <>
      <MainHeader setOpen={setOpen} />
      <Flex>
        {!matches && <MainSidebar />}
        <Box w={matches ? "100vw" : "calc(100vw - 240px)"}>{children}</Box>
        {matches && open && (
          <Box
            pos="relative"
            bg="rgba(128, 128, 128, 0.5)"
            top={0}
            style={{ zIndex: 999 }}
          >
            <Box
              w="100vw"
              h="100vh"
              bg="rgba(128, 128, 128, 0.5)"
              pos="fixed"
              className="pointer"
              top={0}
              left={0}
              onClick={() => setOpen(false)}
            />
            <Box pos="fixed" top={0} left={0}>
              <MainSidebar />
            </Box>
          </Box>
        )}
        {showAlert && location.pathname !== "/report" && (
          <Alert
            title={t("outdated_report_title")}
            color="violet"
            withCloseButton
            variant="filled"
            onClose={() => setShowAlert(false)}
            style={{
              position: "fixed",
              bottom: rem(30),
              left: rem(30),
              zIndex: 4,
              width: rem(360),
              maxWidth: "90%",
              boxShadow: theme.shadows.lg,
            }}
          >
            <Text size="sm" mb="lg">
              {t("outdated_message")}
            </Text>
            <Flex justify="space-between">
              <div />
              <Button
                size="xs"
                onClick={() => {
                  navigate("/profile/edit/contacts");
                  setShowAlert(false);
                }}
              >
                {t("go_edit")}
              </Button>
            </Flex>
          </Alert>
        )}
      </Flex>
    </>
  );
};
